import React, { FC } from "react"
import { Spacer, StatusBubble } from "../../atoms/Atoms"
import { RRIconBar } from "../../atoms/roundedrectangle/RRIconBar"
import { RoundedRectangle } from "../../atoms/roundedrectangle/RoundedRectangle"
import { H3 } from "@carrotfertility/carotene"
import { BodySmall } from "../../atoms/Bodies"
import { CarrotCardModuleProps } from "components/views/molecules/CarrotCardModuleContainer"
import { SupportCenterLinks } from "../../../../utils/SupportCenterLinks"
import { ZendeskArrowLink } from "../../atoms/links/ZendeskArrowLink"
import { FormattedMessage, useIntl } from "react-intl"

const CarrotCardShippedModule: FC<CarrotCardModuleProps> = () => {
  const intl = useIntl()
  return (
    <RoundedRectangle backgroundColor="pampas">
      <RRIconBar
        iconName="icn-carrot-cards"
        iconBackgroundColor="white-60"
        label={
          <StatusBubble backgroundColor="strong-cyan-blue" status={intl.formatMessage({ defaultMessage: "Shipped" })} />
        }
      />
      <H3 variant="primary" stack="tiny">
        <FormattedMessage defaultMessage="Carrot Card®" />
      </H3>
      <BodySmall color="black-80">
        <FormattedMessage defaultMessage="Your card has shipped. Activate it when it arrives so you can start using it right away." />
      </BodySmall>
      <Spacer height={0.5} />
      <ZendeskArrowLink supportCenterLink={SupportCenterLinks.CARROT_CARD_SUPPORT_CENTER}>
        <FormattedMessage defaultMessage="Learn how Carrot Card works" />
      </ZendeskArrowLink>
    </RoundedRectangle>
  )
}

export { CarrotCardShippedModule }
